// extracted by mini-css-extract-plugin
export default {"message":"AutoAssignBeneficiariesModal_message__jnhOU","loader":"AutoAssignBeneficiariesModal_loader__Gw8Sm"};